// Third-party
import React, { ReactElement } from 'react';

// Components
import { SegmentedControl, ControlItem } from '../navigation';

// Enums
import { HoldingAllocationMode } from '@/enums/Portfolio';

// Utils
import { FormattedMessage } from '../../../utils/i18n';

type Props = {
  className?: string;
  onChange: (mode: HoldingAllocationMode) => void;
  value: HoldingAllocationMode;
  modes: HoldingAllocationMode[];
  dark?: boolean;
  disabled?: boolean;
};

const AllocationModeToggle = ({
  className,
  onChange,
  value,
  modes = [HoldingAllocationMode.Weight, HoldingAllocationMode.Units],
  dark,
  disabled,
}: Props): ReactElement => {
  const controlItems = [
    {
      value: HoldingAllocationMode.Weight,
      control: (
        <ControlItem
          key={HoldingAllocationMode.Weight}
          value={HoldingAllocationMode.Weight}
          role="switch"
          aria-checked={value === HoldingAllocationMode.Weight}
        >
          <FormattedMessage id="HoldingsEditor.AllocationMode.Weight" />
        </ControlItem>
      ),
    },
    {
      value: HoldingAllocationMode.Units,
      control: (
        <ControlItem key={HoldingAllocationMode.Units} value={HoldingAllocationMode.Units} role="switch" aria-checked={value === HoldingAllocationMode.Units}>
          <FormattedMessage id="HoldingsEditor.AllocationMode.Units" />
        </ControlItem>
      ),
    },
  ];

  return (
    <SegmentedControl disabled={disabled} className={className} tabStyle dark={dark} onChange={onChange} selected={value}>
      {controlItems.filter(item => modes.includes(item.value)).map(item => item.control)}
    </SegmentedControl>
  );
};

export default AllocationModeToggle;
